export enum Errors {
  CSRFLoadFailed = "csrf/load-failed",
  InternalServerError = "internal/server-error",
  LoginLoadFailed = "login/load-failed",
  LoginUnauthorized = "login/unauthorized",
  ChangePasswordFailed = "auth/change-password-failed",
  ChangeEmailFailed = "auth/change-email-failed",
  LogoutFailed = "auth/logout-failed",
  SendOTPFailed = "auth/send-top-failed",
}
